import { render, staticRenderFns } from "./GroupableItemList.vue?vue&type=template&id=1d5d0125&"
import script from "./GroupableItemList.vue?vue&type=script&lang=js&"
export * from "./GroupableItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports